export default function checarNaoVazio(valor) {
  return valor && valor.length > 0;
}
